import { handleActions } from "redux-actions";
import {
  CATEGORY_DETAILS_LOADED,
  CATEGORY_LOADED,
  SET_CATEGORY_BREADCRUMBS,
  SET_CATEGORY_GENDER,
  SET_CATEGORY_SERVER_ERROR,
  SET_CATEGORY_CHILD_LINKS,
  SET_CATEGORY_IS_BRAND
} from "./constants";
import { mapBreadcrumbs } from "./mapBreadcrumbs";

export {
  setCategoryBreadcrumbs,
  setCategoryGender,
  setCategoryServerError,
  setCategoryChildLinks,
  setCategoryIsBrand
} from "./actions";
export {
  getCategoryChildLinks,
  getCategoryDetails,
  getCategoryId,
  getCategoryGender,
  getCategoryTitle,
  getCategoryBreadcrumbs,
  getCategoryServerError,
  getCategoryHeaderDescription,
  getCategoryIsBrand
} from "./selectors";

const initialState = {};

export default handleActions(
  {
    [CATEGORY_DETAILS_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        details: payload
      };
    },

    [CATEGORY_LOADED]: (state, { error, payload }) => {
      if (error) {
        return { ...state };
      }

      return {
        ...state,
        childLinks: payload.categories,
        breadcrumbs: mapBreadcrumbs(payload.breadcrumb)
      };
    },

    [SET_CATEGORY_BREADCRUMBS]: (state, action) => ({
      ...state,
      breadcrumbs: action.payload
    }),

    [SET_CATEGORY_GENDER]: (state, action) => ({
      ...state,
      gender: action.payload
    }),

    [SET_CATEGORY_SERVER_ERROR]: (state, action) => {
      const { status, message = "" } = action.payload;

      return {
        ...state,
        serverError: {
          status,
          isTimeout: message.includes("timeout")
        }
      };
    },

    [SET_CATEGORY_CHILD_LINKS]: (state, action) => ({
      ...state,
      childLinks: action.payload
    }),

    [SET_CATEGORY_IS_BRAND]: (state, action) => ({
      ...state,
      isBrand: action.payload
    })
  },
  initialState
);
